import "regenerator-runtime/runtime";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import { takeEvery, put } from 'redux-saga/effects';
import { addScrollBlocker, removeScrollBlocker } from '../scroll-blockers/actions';
import * as actions from './actions';
var startWork = /*#__PURE__*/regeneratorRuntime.mark(function startWork(_ref) {
  var showSpinner, messageId, _ref$restoreFocus, restoreFocus, _ref$overlayDelay, overlayDelay;

  return regeneratorRuntime.wrap(function startWork$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          showSpinner = _ref.showSpinner, messageId = _ref.messageId, _ref$restoreFocus = _ref.restoreFocus, restoreFocus = _ref$restoreFocus === void 0 ? true : _ref$restoreFocus, _ref$overlayDelay = _ref.overlayDelay, overlayDelay = _ref$overlayDelay === void 0 ? 0 : _ref$overlayDelay;
          _context.next = 3;
          return put(addScrollBlocker());

        case 3:
          _context.next = 5;
          return put(actions.showWorkingIndicator({
            showSpinner: showSpinner,
            messageId: messageId,
            restoreFocus: restoreFocus,
            overlayDelay: overlayDelay
          }));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, startWork);
});
var endWork = /*#__PURE__*/regeneratorRuntime.mark(function endWork() {
  return regeneratorRuntime.wrap(function endWork$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return put(removeScrollBlocker());

        case 2:
          _context2.next = 4;
          return put(actions.hideWorkingIndicator());

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, endWork);
}); // Show the working indicator

export var watchWorkingStart = /*#__PURE__*/regeneratorRuntime.mark(function watchWorkingStart() {
  return regeneratorRuntime.wrap(function watchWorkingStart$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeEvery(actions.WORKING_START, startWork);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, watchWorkingStart);
}); // Hide the working indicator

export var watchWorkingEnd = /*#__PURE__*/regeneratorRuntime.mark(function watchWorkingEnd() {
  return regeneratorRuntime.wrap(function watchWorkingEnd$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeEvery(actions.WORKING_END, endWork);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, watchWorkingEnd);
});